/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Parameter Name
 */
export const Parameter = {
  NeuronsFundEconomics: "neurons_fund_economics",
  VotingPowerEconomics: "voting_power_economics",
} as const;
/**
 * Parameter Name
 */
export type Parameter = ClosedEnum<typeof Parameter>;

export type GetApiV3NetworkEconomicsParametersParameterRequest = {
  /**
   * Parameter Name
   */
  parameter: Parameter;
};

/** @internal */
export const Parameter$inboundSchema: z.ZodNativeEnum<typeof Parameter> = z
  .nativeEnum(Parameter);

/** @internal */
export const Parameter$outboundSchema: z.ZodNativeEnum<typeof Parameter> =
  Parameter$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace Parameter$ {
  /** @deprecated use `Parameter$inboundSchema` instead. */
  export const inboundSchema = Parameter$inboundSchema;
  /** @deprecated use `Parameter$outboundSchema` instead. */
  export const outboundSchema = Parameter$outboundSchema;
}

/** @internal */
export const GetApiV3NetworkEconomicsParametersParameterRequest$inboundSchema:
  z.ZodType<
    GetApiV3NetworkEconomicsParametersParameterRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    parameter: Parameter$inboundSchema,
  });

/** @internal */
export type GetApiV3NetworkEconomicsParametersParameterRequest$Outbound = {
  parameter: string;
};

/** @internal */
export const GetApiV3NetworkEconomicsParametersParameterRequest$outboundSchema:
  z.ZodType<
    GetApiV3NetworkEconomicsParametersParameterRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3NetworkEconomicsParametersParameterRequest
  > = z.object({
    parameter: Parameter$outboundSchema,
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3NetworkEconomicsParametersParameterRequest$ {
  /** @deprecated use `GetApiV3NetworkEconomicsParametersParameterRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3NetworkEconomicsParametersParameterRequest$inboundSchema;
  /** @deprecated use `GetApiV3NetworkEconomicsParametersParameterRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3NetworkEconomicsParametersParameterRequest$outboundSchema;
  /** @deprecated use `GetApiV3NetworkEconomicsParametersParameterRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3NetworkEconomicsParametersParameterRequest$Outbound;
}

export function getApiV3NetworkEconomicsParametersParameterRequestToJSON(
  getApiV3NetworkEconomicsParametersParameterRequest:
    GetApiV3NetworkEconomicsParametersParameterRequest,
): string {
  return JSON.stringify(
    GetApiV3NetworkEconomicsParametersParameterRequest$outboundSchema.parse(
      getApiV3NetworkEconomicsParametersParameterRequest,
    ),
  );
}

export function getApiV3NetworkEconomicsParametersParameterRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3NetworkEconomicsParametersParameterRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3NetworkEconomicsParametersParameterRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3NetworkEconomicsParametersParameterRequest' from JSON`,
  );
}
